import { render, staticRenderFns } from "./OptOutSaleDialog.vue?vue&type=template&id=47daefc9&"
import script from "./OptOutSaleDialog.vue?vue&type=script&lang=ts&"
export * from "./OptOutSaleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports